import styles from './education.module.css'
import EducationInfoSection from "../../education-info-section/education-info-section";
import EducationCardsSection from "../../education-cards-section/education-cards-section";
import SEO from '../../../utils/SEO';


function Education() {

    return (
        <div>
        <div className={styles.info}>
        <SEO
        title="Обучающие курсы от Invest Era"
        description="Научись принимать правильные решения на фондовом рынке. 7 блоков для разных уровней подготовки"
        ogTitle="Обучающие курсы от Invest Era"
        ogDescription="Научись принимать правильные решения на фондовом рынке. 7 блоков для разных уровней подготовки"
      />

            <EducationInfoSection />
            </div>
            <div className={styles.cardsSection}>
                <EducationCardsSection/>
            </div>

        </div>
    )
}

export default Education